import { useTranslation } from 'react-i18next';
import { clsx } from 'clsx';
import { TEMPLATE_DEFINITIONS } from './templates';
import type { EmailTemplateType } from './types';

interface TemplateGalleryProps {
  selectedTemplate: EmailTemplateType;
  onSelect: (type: EmailTemplateType) => void;
  allowedTemplates?: EmailTemplateType[];
}

export function TemplateGallery({ selectedTemplate, onSelect, allowedTemplates }: TemplateGalleryProps) {
  const { t } = useTranslation();

  const templates = allowedTemplates
    ? TEMPLATE_DEFINITIONS.filter(td => allowedTemplates.includes(td.type))
    : TEMPLATE_DEFINITIONS;

  return (
    <div className="flex gap-2 overflow-x-auto pb-2 scrollbar-thin">
      {templates.map((td) => {
        const Icon = td.icon;
        const isSelected = selectedTemplate === td.type;
        return (
          <button
            key={td.type}
            type="button"
            onClick={() => onSelect(td.type)}
            className={clsx(
              'flex shrink-0 flex-col items-center gap-1.5 rounded-xl border-2 p-3 transition-all w-[110px]',
              isSelected
                ? 'border-accent bg-accent/5 shadow-sm'
                : 'border-border-default hover:border-border-hover'
            )}
          >
            <div
              className="flex h-9 w-9 items-center justify-center rounded-lg"
              style={{ backgroundColor: td.defaultColors.brandColor + '18' }}
            >
              <Icon
                className="h-4.5 w-4.5"
                style={{ color: td.defaultColors.brandColor }}
              />
            </div>
            <span className="text-xs font-medium text-text-primary text-center leading-tight">
              {t(td.labelKey)}
            </span>
          </button>
        );
      })}
    </div>
  );
}
